@if (details(); as d) {
  <soft-event-detail [details]="d" data-testid="external-event-modal" />
}
